var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.75,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 80V0h91.75v25.67H41.14v7.43h50.61v19.19H41.14V59h50.61v21z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MS43NSIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDkxLjc1IDgwIj4KICA8cGF0aCBkPSJNMCw4MFYwSDkxLjc1VjI1LjY3SDQxLjE0VjMzLjFIOTEuNzVWNTIuMjlINDEuMTRWNTlIOTEuNzVWODBaIiBmaWxsPSIjZThmZmEyIi8+Cjwvc3ZnPgo=";
export { SvgLetterE as ReactComponent };